const BASE = ''

export async function apiFetch(url: string, options: RequestInit = {}) {
  const res = await fetch(`${BASE}${url}`, {
    ...options,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
  if (res.status === 401) {
    if (typeof window !== 'undefined') window.location.href = '/login'
    return null
  }
  return res
}

export async function apiGet<T>(url: string): Promise<T | null> {
  const res = await apiFetch(url)
  if (!res) return null
  return res.json()
}

export async function apiPost<T>(url: string, body?: unknown): Promise<T | null> {
  const res = await apiFetch(url, { method: 'POST', body: body ? JSON.stringify(body) : undefined })
  if (!res) return null
  return res.json()
}

export async function apiPut<T>(url: string, body: unknown): Promise<T | null> {
  const res = await apiFetch(url, { method: 'PUT', body: JSON.stringify(body) })
  if (!res) return null
  return res.json()
}

export async function apiDelete(url: string): Promise<boolean> {
  const res = await apiFetch(url, { method: 'DELETE' })
  return res?.ok ?? false
}

export async function login(email: string, password: string): Promise<{ ok: boolean; user?: unknown; detail?: string }> {
  const res = await fetch('/api/auth/login', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  })
  return res.json()
}

export async function logout() {
  await apiPost('/api/auth/logout')
  window.location.href = '/login'
}
